<script setup lang="ts">
import { ref, provide } from 'vue';
import useMaskStore from '@shop/store/mask';

const selectedKey = ref<string | null>(null);
const overflowing = ref<boolean>(false);
const maskStore = useMaskStore();

const toggle = (key?: string | Event) => {
  if (typeof key === 'string') {
    selectedKey.value = selectedKey.value === key ? null : key;
    if (selectedKey.value) {
      maskStore.show();
    } else {
      maskStore.close();
    }
    return;
  }

  if (key && key instanceof Event && key.target) {
    const target = key.target as HTMLElement;
    const link = target.closest('a[data-item-key]') as HTMLElement | null;
    const itemKey = link?.getAttribute('data-item-key');

    if (itemKey) {
      selectedKey.value = selectedKey.value === itemKey ? null : itemKey;
      if (selectedKey.value) {
        maskStore.show();
      } else {
        maskStore.close();
      }
    }
  }
};

const closeMenu = () => {
  selectedKey.value = null;
  maskStore.close();
};

provide('mainMenu', {
  selectedKey,
  overflowing,
  toggle,
  closeMenu,
});

defineExpose({ selectedKey, overflowing, toggle, closeMenu });
</script>

<template>
  <div
    class="main-menu__container"
    :class="{
      'main-menu__container--open force-zindex--high': selectedKey,
      'main-menu__container--overflowing': overflowing,
    }"
    @mouseleave="closeMenu"
  >
    <slot
      :selected-key="selectedKey"
      :overflowing="overflowing"
      :toggle="toggle"
      :close-menu="closeMenu"
    >
      <!-- Default slot content if nothing provided -->
    </slot>
  </div>
</template>

<style lang="scss"></style>
